/** generic data dialog model */
export * from './byd-generic-dialog-data';
